import React from "react";
import styles from "./thankYou.module.css";

import checkmark from "../../assets/icons/right.svg";
import { useLanguage } from "../../context/LanguageContext";
import { useHotel } from "../../context/HotelContext";
import { Header } from "../../components/components";
import {
    IMAGE_ROOT_URL,
} from '../../services/api';
import TajThankYouMessage from './TajThankYouMessage';

const ThankYou = () => {
  const { hotelDetails } = useHotel();
  const {t}=useLanguage();

  const getThankYouMsg = () => {
    if (hotelDetails.hotel_term?.length) {
      const dataItem = hotelDetails.hotel_term.find(
        (item) => item.type === "connect_thanks_cart"
      );
      if (dataItem) return dataItem.term;
      else return t['thank_you_place_request'];
    }
    return t['thank_you_place_request'];
  };

    return (
        <>
        {hotelDetails.id === 746 ? (
            <div className='header-new border-b border-primaryBorder flex items-center w-full sticky top-0 bg-white z-10'>
                <div className='flex items-center justify-between pl-2 pr-2 w-full h-full py-1'>
                    <div className='header-container flex items-center gap-4 h-full justify-between w-full'>
                        <div className='w-6 h-6'></div>
                        <img
                            src={IMAGE_ROOT_URL + hotelDetails?.logo}
                            alt='primary'
                            className='w-full h-full object-contain max-w-28'
                        />
                        <div className='w-6 h-6'></div>
                    </div>
                </div>
            </div>
        ) : (
            <Header />
        )}
            <div className={styles.laundryConfirmation}>
                <img src={checkmark} alt='' />
                {hotelDetails.id === 746 ? (
                    <TajThankYouMessage />
                ) : (
                    <p dangerouslySetInnerHTML={{ __html: getThankYouMsg() }}></p>
                )}
            </div>
        </>
    );
};

export default ThankYou;
